import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary.js';
import { securityMasterLoader } from './data/securityMaster';

// Kick off background security loading immediately on startup so that all
// 4 API loaders (Finnhub, Polygon, Twelve Data, FMP) + CoinGecko begin
// fetching before the first React render.  The loader is idempotent, so
// calling init() again inside useSecurityMaster is safe.
securityMasterLoader.init().catch(() => { /* errors surfaced via UI status */ });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
